// extracted by mini-css-extract-plugin
module.exports = {"container":"AookSelectAosrs_container__2af5p","title":"AookSelectAosrs_title__3Bf6D","add":"AookSelectAosrs_add__3NcI4"};